import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { volverTrasGuardar } from "../../../utils/volverTrasGuardar";

const FormularioPiso = ({ modo }) => {
  const navigate = useNavigate();
  const { id } = useParams();  // el ID del piso a editar
  const [originalId, setOriginalId] = useState("");  // para PUT si cambia

  const [form, setForm] = useState({
    id: "",
    abreviatura: "",
    user_supervisora: "",
    user_comprador: "",
    ruta: "",
    franja_horaria: "",
    supermercado: "",
    plazas_ocupadas: "",
    empresa: "",
    sexo: "",
    servicio: "",
    horas_dia: "",
    horas_semana: "",
    id_asistenta: "",
    nombre_asistenta: "",
    l_e: "", l_s: "",
    m_e: "", m_s: "",
    x_e: "", x_s: "",
    j_e: "", j_s: "",
    v_e: "", v_s: "",
    s_e: "", s_s: "",
  });

  const [usuarios, setUsuarios] = useState({
    supervisoras: [],
    compradores: [],
  });

  const [franjas, setFranjas] = useState([]);
  const [supermercados, setSupermercados] = useState([]);
  const [error, setError] = useState(null);

  // 🔄 Cargar datos iniciales
  useEffect(() => {
    axios.get(`/api/pisos/usuarios-por-tipo`)
      .then(res => setUsuarios(res.data))
      .catch(() => alert("❌ Error cargando usuarios"));

    axios.get(`/api/pisos/franjas`)
      .then(res => {
        const raw = res.data;
        const data = Array.isArray(raw) ? raw : (Array.isArray(raw?.franjas) ? raw.franjas : []);
        const normalized = data
          .map((item) => (typeof item === 'object' && item !== null)
            ? (item.franja ?? item.franja_horaria ?? '')
            : item)
          .filter(Boolean);
        setFranjas(normalized);
      })
      .catch(() => alert("❌ Error cargando franjas"));

    axios.get(`/api/pisos/supermercados-distinct/`)
      .then(res => setSupermercados(res.data))
      .catch(() => setSupermercados([]));
  }, []);

  // 🔄 Si está en modo edición, cargar datos del piso
  useEffect(() => {
    if (modo === "editar" && id) {
      axios.get(`/api/pisos/${id}`)
        .then(res => {
          if (res.data) {
            const d = res.data;
            setForm({
              id: d.id || "",
              abreviatura: d.abreviatura || "",
              user_supervisora: d.user_supervisora || "",
              user_comprador: d.user_comprador || "",
              ruta: d.ruta ?? "",
              franja_horaria: d.franja_horaria || "",
              supermercado: d.supermercado || "",
              plazas_ocupadas: d.plazas_ocupadas ?? "",
              empresa: d.empresa || "",
              sexo: d.sexo || "",
              servicio: d.servicio || "",
              horas_dia: d.horas_dia || "",
              horas_semana: d.horas_semana || "",
              id_asistenta: d.id_asistenta ?? "",
              nombre_asistenta: d.nombre_asistenta || "",
              l_e: d.l_e || "", l_s: d.l_s || "",
              m_e: d.m_e || "", m_s: d.m_s || "",
              x_e: d.x_e || "", x_s: d.x_s || "",
              j_e: d.j_e || "", j_s: d.j_s || "",
              v_e: d.v_e || "", v_s: d.v_s || "",
              s_e: d.s_e || "", s_s: d.s_s || "",
            });
            setOriginalId(d.id);
          } else {
            alert("❌ Piso no encontrado");
            navigate("/admin/pisos");
          }
        })
        .catch(() => alert("❌ Error al cargar el piso"));
    }
  }, [modo, id, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (!form.id || !form.abreviatura) {
      alert("❗ Los campos ID y Abreviatura son obligatorios.");
      return;
    }

    if (!window.confirm("¿Confirmar operación?")) return;

    const url = modo === "editar"
      ? `/api/pisos/${originalId}`
      : `/api/pisos/`;

    const method = modo === "editar" ? "put" : "post";

    try {
      // Convertir cadenas vacías a null para campos opcionales
      const payload = Object.fromEntries(
        Object.entries(form).map(([k, v]) => [k, v === "" ? null : v])
      );
      await axios[method](url, payload);
      alert(modo === "editar" ? "✅ Piso actualizado" : "✅ Piso creado");
      volverTrasGuardar(navigate, "/admin/pisos");
    } catch (err) {
      const msg = err.response?.data?.error || "❌ Error inesperado.";
      setError(msg);
      alert(msg);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h2 style={styles.title}>{modo === "editar" ? "✏️ Editar Piso" : "🆕 Nuevo Piso"}</h2>
        {error && <p style={styles.error}>{error}</p>}
        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.fila2}>
            <div style={styles.campo}>
              <label style={styles.label}>ID</label>
              <input
                name="id"
                placeholder="ID"
                value={form.id}
                onChange={handleChange}
                required
                disabled={modo === "editar"}
                style={{ ...styles.input, ...(modo === "editar" ? styles.inputDisabled : {}) }}
              />
            </div>
            <div style={styles.campo}>
              <label style={styles.label}>Abreviatura</label>
              <input name="abreviatura" placeholder="Abreviatura" value={form.abreviatura} onChange={handleChange} required style={styles.input} />
            </div>
          </div>

          <div style={styles.fila2}>
            <div style={styles.campo}>
              <label style={styles.label}>Empresa</label>
              <select name="empresa" value={form.empresa} onChange={handleChange} style={styles.select}>
                <option value="">-- Empresa --</option>
                <option value="CH">CH</option>
                <option value="CM">CM</option>
              </select>
            </div>
            <div style={styles.campo}>
              <label style={styles.label}>Plazas ocupadas</label>
              <input type="number" name="plazas_ocupadas" placeholder="Plazas ocupadas" value={form.plazas_ocupadas} onChange={handleChange} min={0} style={styles.input} />
            </div>
          </div>

          <div style={styles.fila2}>
            <div style={styles.campo}>
              <label style={styles.label}>Sexo</label>
              <select name="sexo" value={form.sexo} onChange={handleChange} style={styles.select}>
                <option value="">-- Sexo --</option>
                <option value="M">M</option>
                <option value="H">H</option>
              </select>
            </div>
            <div style={styles.campo}>
              <label style={styles.label}>Servicio</label>
              <select name="servicio" value={form.servicio} onChange={handleChange} style={styles.select}>
                <option value="">-- Servicio --</option>
                <option value="G">G</option>
                <option value="TI">TI</option>
                <option value="PLUS">PLUS</option>
                <option value="PRIME">PRIME</option>
                <option value="YP">YP</option>
                <option value="CTA">CTA</option>
              </select>
            </div>
          </div>

          <div style={styles.fila2}>
            <div style={styles.campo}>
              <label style={styles.label}>Horas/día</label>
              <input name="horas_dia" placeholder="HH:MM:SS" value={form.horas_dia} onChange={handleChange} style={styles.input} />
            </div>
            <div style={styles.campo}>
              <label style={styles.label}>Horas/semana</label>
              <input name="horas_semana" placeholder="HH:MM:SS" value={form.horas_semana} onChange={handleChange} style={styles.input} />
            </div>
          </div>

          <div style={styles.fila2}>
            <div style={styles.campo}>
              <label style={styles.label}>ID asistenta</label>
              <input type="number" name="id_asistenta" placeholder="ID asistenta" value={form.id_asistenta} onChange={handleChange} style={styles.input} />
            </div>
            <div style={styles.campo}>
              <label style={styles.label}>Nombre asistenta</label>
              <input name="nombre_asistenta" placeholder="Nombre asistenta" value={form.nombre_asistenta} onChange={handleChange} style={styles.input} />
            </div>
          </div>

          <div style={styles.fila2}>
            <div style={styles.campo}>
              <label style={styles.label}>Supervisora</label>
              <select name="user_supervisora" value={form.user_supervisora} onChange={handleChange} style={styles.select}>
                <option value="">-- Supervisora --</option>
                {usuarios.supervisoras.map(u => (
                  <option key={u.user} value={u.user}>{u.user}</option>
                ))}
              </select>
            </div>
            <div style={styles.campo}>
              <label style={styles.label}>Comprador</label>
              <select name="user_comprador" value={form.user_comprador} onChange={handleChange} style={styles.select}>
                <option value="">-- Comprador --</option>
                {usuarios.compradores.map(u => (
                  <option key={u.user} value={u.user}>{u.user}</option>
                ))}
              </select>
            </div>
          </div>

          <div style={styles.fila2}>
            <div style={styles.campo}>
              <label style={styles.label}>Ruta</label>
              <select name="ruta" value={form.ruta} onChange={handleChange} style={styles.select}>
                <option value="">-- Ruta --</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
              </select>
            </div>
            <div style={styles.campo}>
              <label style={styles.label}>Franja horaria</label>
              <input
                name="franja_horaria"
                placeholder="Ej. 12:00-13:00"
                value={form.franja_horaria}
                onChange={handleChange}
                list="franjas_list"
                style={styles.input}
              />
              <datalist id="franjas_list">
                {franjas.map(f => <option key={f} value={f} />)}
              </datalist>
            </div>
          </div>

          <div style={styles.campo}>
            <label style={styles.label}>Supermercado</label>
            <select name="supermercado" value={form.supermercado} onChange={handleChange} style={styles.select}>
              <option value="">-- Supermercado --</option>
              <option value="B">B</option>
              <option value="M">M</option>
              <option value="-">-</option>
            </select>
          </div>

          <fieldset style={styles.fieldset}>
            <legend style={styles.legend}>🗓️ Horario semanal</legend>
            {[
              ["l", "Lunes"], ["m", "Martes"], ["x", "Miércoles"],
              ["j", "Jueves"], ["v", "Viernes"], ["s", "Sábado"],
            ].map(([k, label]) => (
              <div key={k} style={styles.diaFila}>
                <label style={styles.diaLabel}>{label}</label>
                <input
                  type="time" step="1"
                  name={`${k}_e`} value={form[`${k}_e`] || ""} onChange={handleChange}
                  placeholder="Entrada" style={styles.inputHora}
                />
                <span style={styles.flecha}>→</span>
                <input
                  type="time" step="1"
                  name={`${k}_s`} value={form[`${k}_s`] || ""} onChange={handleChange}
                  placeholder="Salida" style={styles.inputHora}
                />
              </div>
            ))}
          </fieldset>

          <div style={styles.botones}>
            <button type="button" onClick={() => navigate(-1)} style={styles.btnCancelar}>
              Cancelar
            </button>
            <button type="submit" style={styles.btnGuardar}>
              {modo === "editar" ? "💾 Guardar cambios" : "➕ Crear Piso"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const styles = {
  page: { padding: "32px 16px", background: "#f4f6f8", minHeight: "100vh" },
  card: {
    maxWidth: 680, margin: "0 auto", background: "#fff", borderRadius: 16,
    boxShadow: "0 8px 28px rgba(0,0,0,0.08)", padding: "32px 36px",
  },
  title: { margin: "0 0 22px", fontSize: 22, color: "#263238" },
  error: {
    background: "#fdecea", color: "#c0392b", border: "1px solid #f3c2bd",
    borderRadius: 8, padding: "10px 14px", marginBottom: 16, fontSize: 14,
  },
  form: { display: "flex", flexDirection: "column", gap: 18 },
  fila2: { display: "flex", gap: 16, flexWrap: "wrap" },
  campo: { display: "flex", flexDirection: "column", gap: 6, flex: 1, minWidth: 180 },
  label: { fontSize: 12, fontWeight: 700, color: "#607d8b", textTransform: "uppercase", letterSpacing: 0.4 },
  input: { padding: "11px 14px", fontSize: 15, border: "1px solid #cfd8dc", borderRadius: 10, outline: "none" },
  inputDisabled: { background: "#f5f5f5", color: "#90a4ae" },
  select: { padding: "11px 14px", fontSize: 15, border: "1px solid #cfd8dc", borderRadius: 10, cursor: "pointer", background: "#fff" },
  fieldset: { border: "1px solid #e0e0e0", borderRadius: 12, padding: "10px 18px 16px" },
  legend: { padding: "0 8px", fontWeight: 700, color: "#37474f", fontSize: 14 },
  diaFila: { display: "flex", gap: 10, alignItems: "center", padding: "8px 0", borderBottom: "1px solid #f0f0f0" },
  diaLabel: { width: 90, fontSize: 13, fontWeight: 600, color: "#455a64" },
  inputHora: { padding: "8px 10px", fontSize: 14, border: "1px solid #cfd8dc", borderRadius: 8, flex: 1 },
  flecha: { color: "#b0bec5", fontSize: 14 },
  botones: { display: "flex", gap: 12, marginTop: 8 },
  btnCancelar: {
    flex: 1, background: "#fff", color: "#c0392b", border: "1px solid #e57373",
    padding: "12px", borderRadius: 10, fontWeight: 700, cursor: "pointer", fontSize: 15,
  },
  btnGuardar: {
    flex: 1, background: "linear-gradient(135deg,#43a047,#2e7d32)", color: "#fff", border: "none",
    padding: "12px", borderRadius: 10, fontWeight: 700, cursor: "pointer", fontSize: 15,
    boxShadow: "0 4px 10px rgba(46,125,50,0.35)",
  },
};

export default FormularioPiso;
